import { Outlet, useMatch, Navigate } from "react-router";
import NotFoundPage from "./notfound";
import AppComponent from "./AppComponent";
import { Toast } from "../libs/toast";
import { PAGE_NAME } from "../constants/common";
import ScrollToTop from "../components/ScrollToTop";

const RootElements = () => {
  const match = useMatch(`/:channelType`);

  if (match) {
    if (
      !match.params.channelType ||
      !PAGE_NAME.includes(match.params.channelType)
    ) {
      return <NotFoundPage />;
    }
  }
  return (
    <>
      <AppComponent />
      <ScrollToTop />
      <Outlet />
      <Toast />
    </>
  );
};
export default RootElements;
